import { Component, OnInit, Renderer2 } from '@angular/core';
import { gsap } from 'gsap';

@Component({
  selector: 'app-preloader',
  templateUrl: './preloader.component.html',
  styleUrls: ['./preloader.component.scss']
})
export class PreloaderComponent implements OnInit {
  private fallbackTimer?: number;

  constructor(private renderer: Renderer2) { }

  ngOnInit(): void {
    // Keep preloader visible until page fully loads, then animate out.
    // Also install a fallback timeout to ensure the loader is removed
    // even if the load event or GSAP animation doesn't fire.
    if (document.readyState === 'complete') {
      this.hidePreloader();
      return;
    }

    const onLoad = () => this.hidePreloader();
    window.addEventListener('load', onLoad, { once: true });

    // Fallback: forcibly remove the loader after 5s to avoid a stuck black screen
    this.fallbackTimer = window.setTimeout(() => this.hidePreloader(), 5000);
  }

  hidePreloader() {
    if (this.fallbackTimer) {
      clearTimeout(this.fallbackTimer);
      this.fallbackTimer = undefined;
    }

    try {
      gsap.to('.loader', { opacity: 0, duration: 0.55, ease: 'power3.out', onComplete: () => {
        const el = document.querySelector('.loader') as HTMLElement;
        if (el && el.parentNode) { el.parentNode.removeChild(el); }
      }});
    } catch (e) {
      const el = document.querySelector('.loader') as HTMLElement;
      if (el && el.parentNode) { el.parentNode.removeChild(el); }
    }
  }

}
